const faqItems = [
  {
    q: '黑料入口是什么性质的平台？',
    a: '黑料入口是一个百科式科普平台，专注于对各类黑料事件进行背景梳理、经过解读和知识盘点。我们以客观、全面的方式呈现事件信息，帮助读者建立对事件的完整认知，而非简单传播八卦。',
  },
  {
    q: '平台上的信息是否真实可靠？',
    a: '我们坚持多维度交叉验证原则。每篇专题内容均基于公开报道、官方通报、当事人声明等多方信息源综合整理，并在文中标注信息来源。对于未经证实的信息，我们会明确标注"待核实"。',
  },
  {
    q: '如何获取最新的黑料事件更新？',
    a: '本站每日更新，你可以直接访问首页浏览最新专题。重点关注"焦点专题"和"动态快讯"两个板块，前者提供深度解读，后者提供实时更新。建议使用移动端浏览器收藏本站，方便随时查阅。',
  },
  {
    q: '可以投稿或提供爆料线索吗？',
    a: '当然可以！我们非常欢迎读者提供真实可靠的爆料线索。请通过"爆料投稿"区域的邮箱联系我们，所有投稿信息将被严格保密。如果线索被采纳并形成专题，我们会标注信息来源（可选择匿名）。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于黑料入口，你可能想了解的几个问题
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden transition-all duration-200"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-8">
                  {item.q}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}